import { Button, Spinner } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useTheme } from '@/ui/theme'
import ReverCard from '@/ui/components/rever-card'
import type { WithdrawalFormData } from './withdrawal-form'

export const WithdrawalReview = ({
  request,
  isSubmitting,
  onEdit,
  onConfirm
}: {
  request: WithdrawalFormData
  isSubmitting: boolean
  onEdit: () => void
  onConfirm: () => void
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const brand = useAppSelector(
    (store) => store.settingsApi.settings.response.branding?.title
  )

  const rows = [
    { label: t('withdrawal.name_label'), value: request.name },
    { label: t('withdrawal.order_number_label'), value: request.orderNumber },
    { label: t('withdrawal.email_label'), value: request.email }
  ]

  return (
    <ReverCard className="lg:!p-8">
      <div className="space-y-6">
        <header className="space-y-2 text-center">
          <h1 className="text-2xl font-semibold leading-tight [text-wrap:balance]">
            {t('withdrawal.review_title')}
          </h1>
          <p className="text-sm leading-relaxed text-neutral-800 [text-wrap:pretty]">
            {t('withdrawal.review_description', {
              ecommerceName: brand,
              interpolation: { escapeValue: false }
            })}
          </p>
        </header>
        <dl className="space-y-3 rounded-lg border border-solid border-neutral-200 p-4 text-sm">
          {rows.map((row) => (
            <div key={row.label} className="flex justify-between gap-4">
              <dt className="text-neutral-600">{row.label}</dt>
              <dd className="break-all text-right">{row.value}</dd>
            </div>
          ))}
        </dl>
        <div className="flex flex-col gap-3">
          <Button
            size="lg"
            radius="sm"
            fullWidth
            isLoading={isSubmitting}
            spinner={<Spinner size="sm" />}
            style={{
              backgroundColor: theme.colors.primary.main,
              color: theme.colors.primary.contrastText,
              borderRadius: theme.borderRadius
            }}
            onPress={onConfirm}
          >
            {t('withdrawal.confirm')}
          </Button>
          <Button
            size="lg"
            radius="sm"
            variant="bordered"
            fullWidth
            isDisabled={isSubmitting}
            style={{ borderRadius: theme.borderRadius }}
            onPress={onEdit}
          >
            {t('withdrawal.edit')}
          </Button>
        </div>
      </div>
    </ReverCard>
  )
}
